import axios from 'axios'
import {BaseResponse, Pagination, Response} from 'src/app/models'
import {
  IJob,
  IJobBulkRequest,
  IJobDetail,
  IJobQuery,
  IJobRecurringChild,
  IJobRecurringChildQuery,
  IJobRequest,
  ITaskRequest,
} from 'src/app/models/Job/Job.model'

export const JOB = '/api/v1/admins/tasks'

//react-query key
export const LIST_JOB_KEY = 'list-job'
export const DETAIL_JOB_KEY = 'detail-job'

const multiFormDataHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
}

export const getListJob = (params?: IJobQuery) => {
  return axios.get<BaseResponse<Pagination<IJob[]>>>(JOB, {
    params,
  })
}

export const getDetailJob = (id?: string) => {
  return axios.get<BaseResponse<Response<IJobDetail>>>(`${JOB}/${id}`)
}

export const saveJob = (data?: IJobRequest, id?: string) => {
  if (id) return axios.put(`${JOB}/${id}`, data)
  return axios.post(JOB, data)
}

export const updateStatusJob = (job_id?: string, job_status?: 'ACTIVE' | 'INACTIVE') => {
  return axios.patch(`${JOB}/${job_id}/status/${job_status}`)
}

export const updateProgressJob = (
  data?: {reason?: string},
  job_id?: string,
  agent_id?: string,
  job_progress?: 'CLOSE' | 'REJECT'
) => {
  return axios.patch(`${JOB}/${job_id}/agent/${agent_id}/progress/${job_progress}`, data)
}

export const uploadJob = (data?: any) => {
  return axios.post(`${JOB}/upload`, data, {...multiFormDataHeaders})
}

export const uploadBulkJob = (data?: IJobBulkRequest[], session_id?: string) => {
  return axios.post(`${JOB}/bulk/${session_id}`, data)
}

export const uploadedListJob = (params?: IJobQuery, request_id?: string) => {
  return axios.get<BaseResponse<Pagination<{id?: string; name?: string}[]>>>(
    `${JOB}/upload/data/${request_id}`,
    {
      params,
    }
  )
}

export const stopRecurringJob = (id?: string) => {
  return axios.post(`${JOB}/recurring/${id}/stop`)
}

export const getListChildRecurringJob = (params?: IJobRecurringChildQuery, id?: string) => {
  return axios.get<BaseResponse<Pagination<IJobRecurringChild[]>>>(
    `${JOB}/recurring/${id}/childs`,
    {params}
  )
}

export const getListTaskTemplate = (id?: string) => {
  return axios.get<BaseResponse<Response<{forms: ITaskRequest[]}>>>(
    `/api/v1/admins/task-templates/${id}`
  )
}

export const downloadListJob = (params?: IJobQuery) => {
  return axios.get<BaseResponse<Pagination<IJob[]>>>(`${JOB}/reports`, {
    params,
  })
}

export const updateReassignAgentJob = (data: any, agent_id?: string) => {
  return axios.patch(`${JOB}/${agent_id}/reassign`, data)
}

export const reportTemplateJob = (params?: IJobQuery) => {
  return axios.get<
    BaseResponse<
      Response<{
        success?: {
          last_id?: string
          count?: number
          contents?: {
            header?: string
            values?: string[]
          }[]
        }
      }>
    >
  >(`${JOB}/reports/template/download`, {params})
}
